import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PostsPageRoutingModule } from './posts-routing.module';

import { PostsPage } from './posts.page';
import { MyFilterPipe } from '../pipe/MyFilterPipe.pipe';
import { BottombarComponent } from '../components/bottombar/bottombar.component';
import { LikPipe } from '../pipe/link.pipe';
import { PromocionPipe} from '../pipe/publicidad.pipe';
import { MyFilterPipeModule } from '../pipe/myfilter-pipe.module';
import { PublicidadPipeModule } from '../pipe/publicidad-pipe.module';
import { FooterComponentModule } from '../components/footer-component.module';
import { SectionAdvertisementsComponent } from '../components/section-advertisements/section-advertisements.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PostsPageRoutingModule,
    MyFilterPipeModule,
    PublicidadPipeModule,
    FooterComponentModule
  ],
  declarations: [PostsPage,SectionAdvertisementsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class PostsPageModule {}
